<div
  appClickComponent
  [dataComponent]= component()
  appPosition [position]="
  {
    top: component().properties.position.y,
    left: component().properties.position.x
   }"
  [ngStyle]="{
        'width.px':component().properties.size.width ,
        'height.px':component().properties.size.height ,
        }"
  class="  rounded-lg shadow-lg">
  <video
    class="  rounded-lg border border-gray-700"
    controls
    autoplay
    muted
    loop
  >
    <source [src]="component().properties.videoURL" type="video/mp4" />
    Tu navegador no soporta el elemento de video.
  </video>
</div>
